import { SeuCanvas, SeuComponentBase } from '@seu-types';

export function isRezirculationHandleActiveAndConnected(
  component: SeuComponentBase,
  canvas: SeuCanvas
): boolean {
  const streams = canvas.canvasStreams;
  const rezircHandle = component.outputHandles.find((h) => h.isRezirculation);
  if (!rezircHandle) {
    return false;
  }

  return streams.some((s) => s.outputFromComponentHandleId === rezircHandle.id);
}
